__turbopack_context__.v({
  "active": "Services-module-scss-module__TRUVmW__active",
  "bottomHeadings": "Services-module-scss-module__TRUVmW__bottomHeadings",
  "brandLogo": "Services-module-scss-module__TRUVmW__brandLogo",
  "container": "Services-module-scss-module__TRUVmW__container",
  "content": "Services-module-scss-module__TRUVmW__content",
  "contentWrapper": "Services-module-scss-module__TRUVmW__contentWrapper",
  "controlButton": "Services-module-scss-module__TRUVmW__controlButton",
  "controlIcon": "Services-module-scss-module__TRUVmW__controlIcon",
  "controlWheel": "Services-module-scss-module__TRUVmW__controlWheel",
  "ctaButton": "Services-module-scss-module__TRUVmW__ctaButton",
  "heading": "Services-module-scss-module__TRUVmW__heading",
  "headings": "Services-module-scss-module__TRUVmW__headings",
  "leftSection": "Services-module-scss-module__TRUVmW__leftSection",
  "middleSection": "Services-module-scss-module__TRUVmW__middleSection",
  "mobileCta": "Services-module-scss-module__TRUVmW__mobileCta",
  "modal": "Services-module-scss-module__TRUVmW__modal",
  "modalCloseButton": "Services-module-scss-module__TRUVmW__modalCloseButton",
  "modalContent": "Services-module-scss-module__TRUVmW__modalContent",
  "modalCta": "Services-module-scss-module__TRUVmW__modalCta",
  "musicPlayer": "Services-module-scss-module__TRUVmW__musicPlayer",
  "promoInfo": "Services-module-scss-module__TRUVmW__promoInfo",
  "rightSection": "Services-module-scss-module__TRUVmW__rightSection",
  "rightSectionContent": "Services-module-scss-module__TRUVmW__rightSectionContent",
  "screen": "Services-module-scss-module__TRUVmW__screen",
  "screenInnerBorder": "Services-module-scss-module__TRUVmW__screenInnerBorder",
  "screenTitle": "Services-module-scss-module__TRUVmW__screenTitle",
  "slideUp": "Services-module-scss-module__TRUVmW__slideUp",
  "stickySection": "Services-module-scss-module__TRUVmW__stickySection",
  "wheel": "Services-module-scss-module__TRUVmW__wheel",
  "wheelInner": "Services-module-scss-module__TRUVmW__wheelInner",
});
